export default "__VITE_ASSET__D25mB0Kc__"